import { useEffect } from "react";

import { I18nextProvider } from "react-i18next";

import { initializeI18n } from "./i18n";
import type { TranslationProviderProps } from "./types";

const TranslationProvider = ({
  children,
  language = "en",
}: TranslationProviderProps) => {
  const i18n = initializeI18n(language);

  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

TranslationProvider.displayName = "TranslationProvider";

export { TranslationProvider };
